import styled from "styled-components/macro";
import { Link } from "react-router-dom";

export const NavGallery = styled.nav`
  background: #000;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const NavGalleryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogo = styled(Link)`
  color: white;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  margin-left: 24px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
`;
export const NavItem = styled.div`
  height: 80px;
`;

export const NavLinks = styled.div`
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  border-bottom: ${({ active }) => (active ? "3px solid #fff" : undefined)};

  @media screen and (max-width: 480px) {
    border-left: ${({ active }) => (active ? "3px solid #fff" : undefined)};
  }
`;
